export default __webpack_public_path__ + "static/media/castledown-heavy.19635327.woff";